import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact'
import { useEffect } from 'preact/hooks';

import Product from './Product'
// import useProductGroup from "../hooks/useProductGroup"

export default ({ gridView }) => {
    const { response: { products }, loading, pageType } = useAppState();
    // const { swatchData } = useProductGroup();

    useEffect(() => {
        if(!window.nostojs) return;
        window.nostojs(api => {
            api.loadRecommendations({ skipPageViews: true, skipEvents: true })
        })
    }, [ products.hits ]);

    return (
        <div
            class="filters-adjacent collection-listing"
            style={loading ? 'opacity: 0.3;' : ''}
        >
            <div class={`product-grid product-grid--per-row-4 ${gridView ? 'product-grid--per-row-mob-2' : 'product-grid--per-row-mob-1' }`}>
                {products.hits.map((hit, index) => {
                    return (
                        <Product
                            key={hit.productId || index}
                            product={hit}
                            pageType={pageType}
                            // groupData={
                            //     swatchData.find(group => group.products.find(p => p.productId === hit.productId)) ?? false
                            // }
                        />
                    )
                })}
            </div>
        </div>
    )
}
